import dayjs from 'dayjs';
import { selector } from 'recoil';

import { greaseTrapFiltersState } from './greaseTrapFilters';

export const greaseTrapCleanFiltersState = selector({
  key: 'greaseTrapCleanTheFilters',
  get: ({ get }) => {
    // Trigger re-evaluation when filters change, then return a fresh default
    get(greaseTrapFiltersState);

    return {
      vendorId: null,
      vendorName: null,
      vendorNameFilter: null,
      statusFilter: null,
      startDate: dayjs().subtract(30, 'days').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      limit: 10,
      offset: 0,
    };
  },
});
